import { API, graphqlOperation } from "aws-amplify";

import { GraphQLResult } from "@aws-amplify/api-graphql";

type CallsByProjectIdAndCreatedAtQuery = {
    callsByProjectIdAndCreatedAt: {
      items: Array<{
        id: string;
      }>;
      nextToken?: string | null;
    };
  };


/* GraphQL */
const callsByProjectIdAndCreatedAt = `
  query CallsByProjectIdAndCreatedAt(
    $projectId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLLMCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    callsByProjectIdAndCreatedAt(
      projectId: $projectId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

export async function fetchLLMCallsCountRecursive(
  projectId: string,
  limit: number = 5,
  sinceDate: string = new Date().toISOString(),
  nextToken: string | null = null,
  accumulatedCalls: any[] = []
): Promise<GraphQLResult<CallsByProjectIdAndCreatedAtQuery>> {

    const query = {
        projectId: projectId,
        limit: limit,
        nextToken: nextToken,
        createdAt: {
          ge: sinceDate,
        },
      };

  let result: GraphQLResult<CallsByProjectIdAndCreatedAtQuery> | null = null;
  try {
    result = (await API.graphql(
      graphqlOperation(callsByProjectIdAndCreatedAt, query)
    )) as GraphQLResult<CallsByProjectIdAndCreatedAtQuery>;
  } catch (error) {
    console.error('Error fetching calls', error);
  }

  const calls = result?.data?.callsByProjectIdAndCreatedAt?.items || [];
  const newAccumulatedCalls = [...accumulatedCalls, ...calls];
  const newNextToken = result?.data?.callsByProjectIdAndCreatedAt?.nextToken;

  if (newAccumulatedCalls.length >= limit || !newNextToken) {
    return {
      ...result,
      data: {
        ...result?.data,
        callsByProjectIdAndCreatedAt: {
          items: newAccumulatedCalls,
          nextToken: newNextToken,
        },
      },
    };
  }

  return fetchLLMCallsCountRecursive(projectId, limit, sinceDate, newNextToken, newAccumulatedCalls);
}